





import Vue from 'vue'

import { mapGetters } from 'vuex'

export default Vue.extend({
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    type: { type: String, default: 'text' },
    value: { type: String, default: '' }
  },
  computed: {
    ...mapGetters(['getIsPrintablePDFMode']),
    style () {
      const hypothesis = this.value ? this.value.startsWith('h(') && this.value.endsWith(')') : false
      return { input: true, hypothesis: hypothesis }
    }
  },
  methods: {
    update (event: InputEvent) {
      this.$emit('update', (event.target as HTMLInputElement).value)
    }
  }
})

